import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_RDP_LOG } from './rdp-log.shared';
import { rdpLogRoutes } from './rdp-log.routes';

export function provideRdpLogModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'rdpLog',
        title: '#RDP_LOG.APP',
        icon: 'fa-regular fa-display-medical',
        route: '/rdp-log',
        permission: SOFTLINE_PERMISSION_RDP_LOG,
        group: getModuleGroupByName('Technik'),
      },
      withSoftAppsModuleRoutes({ app: rdpLogRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/softline/rdp-log',
        description: 'Protokoll der RDP-Sitzungen bei Softline.',
      })
    ),
  ];
}

export const rdpLogProviders: EnvironmentProviders[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'rdpLog',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#RDP_LOG.APP',
      icon: 'fa-regular fa-display-medical',
      route: '/rdp-log',
      permission: SOFTLINE_PERMISSION_RDP_LOG,
      group: getModuleGroupByName('Technik'),
    });
  }),
];
